import { render } from "./ModalCreateAttribute.vue?vue&type=template&id=efabf514"
import script from "./ModalCreateAttribute.vue?vue&type=script&lang=js"
export * from "./ModalCreateAttribute.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__